import axios, { CancelToken } from 'axios'
import LoginUtils from '@/core/util/login-utils'
import AxiosRequestManager from '@/config/AxiosRequestManager'
import NumberUtils from '@/core/util/number-utils'

const requestManager = new AxiosRequestManager({ debug: false })
const empresaId = 1
const axiosVimeoAPI = axios.create({
  baseURL: process.env.VUE_APP_VIMEO_API_URL,
  params: {}
})

axiosVimeoAPI.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${process.env.VUE_APP_VIMEO_ACCESS_TOKEN}`
  config.headers.Accept = 'application/vnd.vimeo.*+json;version=3.4'
  config.requestId = NumberUtils.generateRandomID()

  const source = CancelToken.source()
  config.cancelToken = source.token
  requestManager.addRequest(config.requestId, source.cancel)

  return config
})

const axiosJalekoAPI = axios.create({
  baseURL: process.env.VUE_APP_JALEKO_BASE_API_URL,
  params: {
    empresaId: empresaId
  }
})

axiosJalekoAPI.interceptors.request.use(config => {
  if (LoginUtils.getToken()) {
    config.headers.Authorization = `Bearer ${LoginUtils.getToken()}`
  }

  config.requestId = NumberUtils.generateRandomID()

  const source = CancelToken.source()
  config.cancelToken = source.token
  requestManager.addRequest(config.requestId, source.cancel)

  return config
})

axiosJalekoAPI.interceptors.response.use(response => response, error => {
  if (error.response && error.response.status === 401) {
    LoginUtils.logout()
    if (window.location.href.includes('/login')) {
      throw error
    } else {
      window.location = '/login'
    }
  } else {
    throw error
  }
})

const axiosjalekoAPIPagamentos = axios.create({
  baseURL: process.env.VUE_APP_JALEKO_BASE_API_PAGAMENTOS_URL,
  params: {
    empresaId: empresaId
  }
})

axiosjalekoAPIPagamentos.interceptors.request.use(config => {
  if (LoginUtils.getTokenPagamento()) {
    config.headers.Authorization = `Bearer ${LoginUtils.getTokenPagamento()}`
  }

  config.requestId = NumberUtils.generateRandomID()

  const source = CancelToken.source()
  config.cancelToken = source.token
  requestManager.addRequest(config.requestId, source.cancel)

  return config
})

export const AxiosConfig = {

  cancelAll: function (reason) {
    requestManager.cancelAllRequests()
  },

  isCancelled: function (error) {
    return axios.isCancel(error)
  },

  jalekoAPI: function () {
    return axiosJalekoAPI
  },

  secureJalekoAPI: function () {
    if (!LoginUtils.getToken()) {
      window.location = '/login'
    }

    return axiosJalekoAPI
  },

  vimeoAPI: function () {
    return axiosVimeoAPI
  },

  jalekoAPIPagamentos: function () {
    return axiosjalekoAPIPagamentos
  },

  secureJalekoAPIPagamentos: function () {
    if (!LoginUtils.getTokenPagamento()) {
      window.location = '/login'
    }

    return axiosjalekoAPIPagamentos
  }
}

export default AxiosConfig
